"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPlanType = void 0;
const constants_1 = require("../constants");
/* eslint-disable require-jsdoc */
class DayPlanType {
    constructor(userId) {
        this.progress = 0.0;
        this.highestCorrectStreak = 0;
        this.finishedModuleCount = 0;
        this.inprogressModuleCount = 0;
        this.todoModuleCount = 0;
        this.estimatedCompletionTime = 0;
        this.actualStudyTime = 0.0;
        this.acquisitionTarget = 0;
        this.acquisitionProgress = 0;
        this.reviewTarget = 0;
        this.reviewProgress = 0;
        this.userId = userId;
    }
    static collectionPath() {
        return constants_1.constants.COLLECTION_PATH_DAY_PLAN;
    }
}
exports.DayPlanType = DayPlanType;
